import React from 'react';
import { domains } from '../../data/domains';

// Threat Vector domain tabs (prototype .domains): mono outline pills, active pill
// fills cyan with a glow. Wraps responsively (no separate mobile dropdown needed).
const DomainSelector = ({ selectedDomain, onDomainChange }) => (
  <div className="tv-domains">
    {domains.map((domain) => (
      <button
        key={domain.id}
        className={selectedDomain === domain.id ? 'active' : ''}
        onClick={() => onDomainChange(domain.id)}
      >
        {domain.label}
      </button>
    ))}
  </div>
);

export default DomainSelector;
